import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { TemplateTwelvePDFSection } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateTwelvePDFSection themeColor={themeColor} heading={heading}>
      <View>
        {summary && <ResumePDFText themeColor={themeColor}>{summary}</ResumePDFText>}
      </View>
    </TemplateTwelvePDFSection>
  );
};
